export default {
  workshop_home_last_update: "Última actualización",
  workshop_home_resp_admin: "Administrativo",
  workshop_home_resp_client: "Cliente",
  workshop_home_resp_workshop: "Taller",
  workshop_quotations_table_date: "Fecha",
  workshop_quotations_table_type: "Tipo",
  workshop_quotations_table_value: "Valor",
  workshop_quotations_table_status: "Estado",
  workshop_quote_attachments_title: "Anexos y Documentos",
  workshop_quote_attachments_tab: "Anexos",
  workshop_quote_invoices_tab: "Facturas",
  workshop_quote_add_attachment_btn: "Añadir Anexo",
  workshop_quote_add_invoice_btn: "Añadir Factura (PDF)",
  workshop_quote_search_label: "ID o Nombre del Equipo",
  workshop_quote_search_placeholder: "Ingrese ID o nombre del equipo...",
  workshop_quote_finance_summary: "Resumen Financiero",
  workshop_quote_total_items_label: "Total Ítems ($)",
  workshop_quote_discount_label: "Descuento ($)",
  workshop_quote_total_final_label: "Total Final ($)",
  workshop_quote_form_no_equip_msg: "Ningún equipo añadido al presupuesto",
  workshop_quote_form_add_item_btn: "Añadir Ítem",
  workshop_quote_form_table_qty: "Cant",
  workshop_quote_form_table_item: "Cod - Nombre",
  workshop_quote_item_type_part: "Pieza",
  workshop_quote_item_type_service: "Servicio",
  workshop_quote_modal_items_title: "Añadir Ítems al Servicio",
  workshop_quote_modal_search_label: "Buscar por nombre o código",
  workshop_quote_modal_search_placeholder: "Ej: CTAT001 o Tornillo",
  workshop_quote_modal_no_items: "Ningún ítem encontrado",
  workshop_quote_overlay_normal_price: "Valor normal",
  workshop_quote_overlay_promo_price: "Valor promocional",
  workshop_search_initial_msg: "Ingrese lo que desea buscar",
  workshop_search_found_companies: "Empresas Encontradas",
  workshop_search_no_companies: "Ninguna empresa encontrada",
  workshop_search_found_quotes: "Cotizaciones Encontradas",
  workshop_search_no_quotes: "Ninguna cotización encontrada",
  workshop_search_query_placeholder: "empresa o cnpj/cif",
  workshop_search_num_placeholder: "nº cotización",
  workshop_respond_id_not_found: "ID de la estimación no encontrado",
  workshop_respond_load_error: "Error al cargar los datos de la estimación",
  workshop_respond_services_load_error: "Error al cargar el catálogo de servicios",
  workshop_respond_empty_item_warning: "Añada al menos un ítem a la respuesta",
  workshop_respond_sent_msg: "¡Respuesta enviada con éxito!",
  workshop_respond_success_alert: "Éxito al enviar respuesta",
  workshop_respond_send_error: "Error al enviar respuesta",
  workshop_respond_no_estimate_loaded: "Ninguna estimación cargada",
  workshop_respond_no_items_msg: "Ningún ítem solicitado",
  workshop_respond_obs_label: "Observación adicional",
  workshop_respond_obs_placeholder: "Ingrese la respuesta...",
  workshop_respond_total_value_label: "Valor Total",
  workshop_respond_finish_btn: "Finalizar Respuesta",
  workshop_respond_item_details_title: "Detalles del Ítem",
  workshop_respond_select_service_title: "Seleccionar Servicio",
  workshop_respond_filter_label: "Filtrar servicios",
  workshop_respond_filter_placeholder: "Buscar por nombre o código...",
  workshop_respond_quantity_label: "Cantidad",
  workshop_respond_add_btn: "Añadir Ítem",
  workshop_respond_client_data_title: "DATOS DEL CLIENTE",
  workshop_respond_estimate_data_title: "DATOS DE LA ESTIMACIÓN",
  workshop_respond_admin_reply_title: "RESPUESTA DEL ADMIN",
  workshop_equipaments_title: "Lista de Equipos",
  workshop_equipaments_add_btn: "Añadir",
  workshop_equip_add_load_equip_error: "No fue posible cargar los datos del equipo",
  workshop_equip_add_load_services_error: "No fue posible cargar la lista de servicios",
  workshop_equip_details_download_error: "Error al descargar el archivo",
  workshop_equip_details_history_title: "Historial de Revisiones",
  workshop_equip_details_id_not_found: "ID del equipo no encontrado",
  workshop_equip_details_item_data_title: "Datos del Ítem",
  workshop_equip_details_last_photos_title: "Últimas Fotos del Equipo",
  workshop_equip_details_load_error: "Error al cargar datos del equipo",
  workshop_equip_details_loading_msg: "Cargando...",
  workshop_equip_details_loading_short_msg: "Cargando...",
  workshop_equip_details_no_data_msg: "Datos del equipo no disponibles.",
  workshop_equip_details_try_again_btn: "Intentar de Nuevo",
  workshop_home_clients_btn: "Clientes",
  workshop_home_equip_not_found: "Equipo no localizado",
  workshop_home_load_error: "No fue posible cargar los datos del dashboard",
  workshop_home_loading_msg: "Cargando datos...",
  workshop_home_no_data_msg: "No se encontraron datos para este estado",
  workshop_home_operation_phases: "Fases de la Operación",
  workshop_home_refresh_btn: "Actualizar",
  workshop_home_reports_btn: "Informes",
  workshop_home_responsible_label: "Responsable",
  workshop_home_search_btn: "Buscar",
  workshop_home_search_btn_main: "Buscar",
  workshop_home_search_cnpj_nota_label: "Buscar por CNPJ o numero de nota",
  workshop_home_search_cnpj_nota_placeholder: "Ingrese el CNPJ o numero de nota",
  workshop_home_search_note_pending_msg: "La busqueda por CNPJ esta activa. La busqueda por nota se habilitara tras la actualizacion del backend en Home.",
  workshop_home_search_equip_btn_main: "Buscar Equipo",
  workshop_home_search_equip_label: "Ingrese el ID del equipo:",
  workshop_home_search_equip_title: "Buscar Equipo",
  workshop_home_select_status: "SELECCIONE UN ESTADO",
  workshop_home_table_client: "Cliente",
  workshop_home_table_cnpj: "CNPJ",
  workshop_home_table_code: "Código",
  workshop_home_table_created: "Creado",
  workshop_home_table_type: "Tipo",
  workshop_quotations_confirm_btn: "Sí, continuar",
  workshop_quotations_create_btn: "Crear Apunte",
  workshop_quotations_create_warning: "Al continuar, generará un nuevo apunte sin vínculo con ninguna estimación. ¿Seguro que desea continuar? (para generar un apunte vinculado, hágalo desde los detalles de la estimación)",
  workshop_quotations_finished_title: "Finalizados",
  workshop_quotations_load_error: "No se pudieron cargar las cotizaciones",
  workshop_quotations_loading_msg: "Cargando...",
  workshop_quotations_no_finished_msg: "Ningún registro finalizado",
  workshop_quotations_no_ongoing_msg: "Ningún registro en curso",
  workshop_quotations_no_pending_msg: "Ningún registro pendiente",
  workshop_quotations_ongoing_title: "En Curso",
  workshop_quotations_page_title: "Cotizaciones",
  workshop_quotations_pending_title: "Pendiente Conmigo",
  workshop_quotations_table_local: "Local",
  workshop_quotations_table_ref: "Ref",
  workshop_quote_anexo_deleted_msg: "Anexo eliminado con éxito",
  workshop_quote_delete_anexo_title: "¿Eliminar anexo?",
  workshop_quote_delete_nota_title: "¿Eliminar factura?",
  workshop_quote_equip_added_warning: "Equipo ya agregado al presupuesto",
  workshop_quote_form_items_title: "Ítems del Presupuesto",
  workshop_quote_form_save_btn: "Guardar Presupuesto",
  workshop_quote_form_tech_label: "Técnico/Responsable",
  workshop_quote_generate_confirm_btn: "Sí, generar presupuesto",
  workshop_quote_generate_title: "Generar Presupuesto",
  workshop_quote_generate_warning: "Esto generará un presupuesto para aprobación administrativa. Asegúrese de haber incluido todas las piezas y procedimientos del servicio. ¿Desea continuar?",
  workshop_quote_no_equip_error: "Agregue al menos un equipo al presupuesto",
  workshop_quote_no_service_linked: "Este equipo no tiene servicio vinculado",
  workshop_quote_nota_deleted_msg: "Factura eliminada con éxito",
  workshop_quote_remove_equip_title: "¿Remover equipo?",
  workshop_quote_remove_item_title: "¿Remover ítem?",
  workshop_quote_save_error: "No fue posible guardar el presupuesto",
  workshop_quote_save_success: "¡Presupuesto guardado con éxito!",
  workshop_quote_service_not_found: "Servicio no encontrado",
  workshop_status_approved: "Aprobado para Mantenimiento",
  workshop_status_finished: "Estado finalizado",
  workshop_status_in_analysis: "Equipo en Análisis",
  workshop_status_pending_approval: "Estado pendiente approval",
  workshop_status_ready: "Listo para Retiro",
  workshop_status_refused: "Estado rechazado",
  workshop_status_waiting_equip: "Esperando Equipo",
  workshop_status_waiting_inspection: "Esperando Inspección e Informe",
  workshop_status_waiting_invoice: "Esperando Facturación",
  workshop_status_waiting_quote: "Estado esperando cotizacion",
  workshop_breadcrumb_quotations: "Cotizaciones",
  workshop_breadcrumb_quote: "Presupuesto",
  workshop_breadcrumb_estimate_respond: "Respuesta de estimación",
  workshop_breadcrumb_search: "Buscar",
  workshop_breadcrumb_add_equipment: "Agregar equipo",
  workshop_status_sent: "Enviado",
  workshop_home_table_header_actions: "Acciones",
  workshop_home_mark_sent_btn: "Marcar como Enviado",
  workshop_home_mark_sent_confirm_title: "Confirmar",
  workshop_home_mark_sent_confirm_text: "Desea avanzar este item a Enviado?",
  workshop_home_mark_sent_success: "Estado actualizado a Enviado.",
  workshop_home_mark_sent_error: "No fue posible actualizar el estado a Enviado.",
  workshop_status_authorize_maintenance: "Autorizar Mantenimiento",
  workshop_home_authorize_maintenance_btn: "Autorizar Mantenimiento",
  workshop_home_authorize_maintenance_confirm_title: "Confirmar",
  workshop_home_authorize_maintenance_confirm_text: "Desea avanzar este item a Autorizar Mantenimiento?",
  workshop_home_authorize_maintenance_success: "Estado actualizado a Autorizar Mantenimiento.",
  workshop_home_authorize_maintenance_error: "No fue posible actualizar el estado a Autorizar Mantenimiento.",
  workshop_home_approve_maintenance_btn: "Aprobar para Mantenimiento",
  workshop_home_approve_maintenance_confirm_title: "Confirmar",
  workshop_home_approve_maintenance_confirm_text: "Desea avanzar este item a Aprobado para Mantenimiento?",
  workshop_home_approve_maintenance_success: "Estado actualizado a Aprobado para Mantenimiento.",
  workshop_home_approve_maintenance_error: "No fue posible actualizar el estado a Aprobado para Mantenimiento.",
  // Quick Company + Quotation Modal
  workshop_home_equip_entry_btn: "Entrada de Equipo",
  workshop_quick_title: "Entrada de Equipo — Registro Rápido",
  workshop_quick_step_company: "Empresa",
  workshop_quick_step_quotation: "Cotización",
  workshop_quick_cnpj: "CNPJ",
  workshop_quick_company_name: "Nombre de la Empresa",
  workshop_quick_responsible: "Nombre del Responsable",
  workshop_quick_email: "E-mail del Responsable",
  workshop_quick_phone: "Teléfono",
  workshop_quick_schema_preview: "Schema (generado automáticamente)",
  workshop_quick_tipo: "Tipo",
  workshop_quick_choice_subtitle: "Elija cómo desea iniciar el servicio",
  workshop_quick_choice_existing: "Empresa Existente",
  workshop_quick_choice_existing_desc: "Seleccione una empresa ya registrada",
  workshop_quick_choice_new: "Nueva Empresa",
  workshop_quick_choice_new_desc: "Registre rápidamente un nuevo cliente",
  workshop_quick_select_company: "Seleccione la empresa",
  workshop_quick_continue: "Continuar",
  workshop_quick_observacoes: "Observaciones",
  workshop_quick_observacoes_placeholder: "Observaciones adicionales (opcional)...",
  workshop_quick_local: "Lugar de Ejecución",
  workshop_quick_equip_service_title: "Equipo y Servicio",
  workshop_quick_equipment: "Equipo",
  workshop_quick_service: "Servicio",
  workshop_quick_select_placeholder: "Seleccione...",
  workshop_quick_details_title: "Detalles",
  workshop_quick_quantity: "Cantidad",
  workshop_quick_model: "Modelo",
  workshop_quick_brand: "Marca",
  workshop_quick_problem: "Problema / Necesidad",
  workshop_quick_problem_placeholder: "Describa el problema o necesidad...",
  workshop_quick_cancel: "Cancelar",
  workshop_quick_next: "Registrar Empresa y Continuar",
  workshop_quick_finish: "Crear Cotización y Finalizar",
  workshop_quick_creating: "Procesando...",
  workshop_quick_company_success: "¡Empresa creada con éxito!",
  workshop_quick_quotation_success: "¡Cotización creada con éxito!",
  workshop_quick_error_missing: "Complete todos los campos obligatorios.",
  workshop_quick_error_exists: "El grupo de empresa ya existe.",
  workshop_quick_error_invalid: "Nombre inválido para schema.",
  workshop_quick_error_email_exists: "Este correo electrónico ya existe y no puede ser registrado.",
  workshop_quick_error_generic: "Ocurrió un error. Inténtelo de nuevo.",
}
